/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hours_WeekdaysInputs */

const en_contact_hours_weekdays = /** @type {(inputs: Contact_Hours_WeekdaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday to Friday`)
};

const pl_contact_hours_weekdays = /** @type {(inputs: Contact_Hours_WeekdaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od poniedziałku do piątku`)
};

/**
* | output |
* | --- |
* | "Monday to Friday" |
*
* @param {Contact_Hours_WeekdaysInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_hours_weekdays = /** @type {((inputs?: Contact_Hours_WeekdaysInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hours_WeekdaysInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_hours_weekdays(inputs)
	return en_contact_hours_weekdays(inputs)
});